import { GESTIONNAIRE_FIELD } from 'business/constants';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
    BUDGET_NAME_FIELD,
    BUDGET_YEAR_FIELD,
    EXPENSE_INCOME_FIELD,
    REALIZED_FIELD,
    AMOUNT_AVAILABLE_FIELD,
    AMOUNT_SPECIAL_AUTHORIZATION_FIELD,
    MANDATED_FIELD,
    REPORTED_FIELD,
    VOTED_FIELD,
    REQUESTED_FIELD,
    AMOUNT_ENGAGED_UNPAID,
    VOTED_TOTAL_FIELD,
    PERCENT_REALIZED_FIELD,
    REAL_ORDER_FIELD,
    LINE_CODE_FIELD,
    LINE_NAME_FIELD,
    ORG_CHART_FINANCE_FIELD,
    ORG_CHART_FINANCE_CODE_FIELD,
    GESTIONNAIRE_CODE_FIELD,
    CHAPTER_FIELD,
    CHAPTER_LABEL_FIELD,
    NATURE_FIELD,
    NATURE_LABEL_FIELD,
    FUNCTION_FIELD,
    FUNCTION_LABEL_FIELD,
    BUDGET_LINE_ID,
    SECTION_FIELD,
    BUDGET_LINE_CODE,
    ORG_CHART_FINANCE_SOFTWARE_ID,
    GESTIONNAIRE_SOFTWARE_ID,
    SUPER_GESTIONNAIRE_CODE_FIELD,
    SUPER_GESTIONNAIRE_FIELD,
    OPERATION_FIELD,
    OPERATION_NAME_FIELD,
    SUPER_OPERATION_FIELD,
    SUPER_OPERATION_NAME_FIELD,
    OPERATION_SEGMENT_CODE,
    OPERATION_SEGMENT_NAME,
    SUB_NATURE_FIELD,
    SUB_NATURE_LABEL_FIELD,
    ANTENNA_FIELD,
    ANTENNA_NAME_FIELD,
    STRAT_FOCUS_CODE,
    STRAT_FOCUS_NAME,
    DIRECTION_CODE,
    DIRECTION_LABEL,
    ANALYTIC_NAME_FIELD,
    ANALYTIC_FIELD,
    ANALYTIC_POST_0_CODE,
    ANALYTIC_POST_0_NAME,
    ANALYTIC_POST_0_TYPE,
    ANALYTIC_POST_1_CODE,
    ANALYTIC_POST_1_NAME,
    ANALYTIC_POST_1_TYPE,
    ANALYTIC_POST_2_CODE,
    ANALYTIC_POST_2_NAME,
    ANALYTIC_POST_2_TYPE,
    ANALYTIC_POST_3_CODE,
    ANALYTIC_POST_3_NAME,
    ANALYTIC_POST_3_TYPE,
    ANALYTIC_POST_4_CODE,
    ANALYTIC_POST_4_NAME,
    ANALYTIC_POST_4_TYPE,
    ANALYTIC_POST_5_CODE,
    ANALYTIC_POST_5_NAME,
    ANALYTIC_POST_5_TYPE,
    ANALYTIC_POST_6_CODE,
    ANALYTIC_POST_6_NAME,
    ANALYTIC_POST_6_TYPE,
    ANALYTIC_POST_7_CODE,
    ANALYTIC_POST_7_NAME,
    ANALYTIC_POST_7_TYPE,
    ANALYTIC_POST_8_CODE,
    ANALYTIC_POST_8_NAME,
    ANALYTIC_POST_8_TYPE,
    ANALYTIC_POST_9_CODE,
    ANALYTIC_POST_9_NAME,
    ANALYTIC_POST_9_TYPE,
    AP_LABEL,
    AP_START_YEAR,
    AP_CODE,
    ENVELOPPE_CODE,
    BUDGET_LINE_PROGRAM_CODE,
    BUDGET_LINE_PROGRAM_NAME,
    ANALYTIC_NATURE_CODE,
    ANALYTIC_NATURE_NAME,
    ENVELOPPE_LABEL,
    AMOUNT_AMENDING_DECISION_FIELD,
    AMOUNT_VOTED_SUP_FIELD,
    EVOLUTION_N_N_1,
    IS_AMPMETROPOLE_BUDGETABLE,
} from 'routes/BudgetModule/config/constants';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

/**
 * Represents the data structure for Expense Income Imputation.
 */
export type ExpenseIncomeImputationDataT = {
    softwareId: string;
    resource_software_id: string;
    canAddInscription: boolean;

    [BUDGET_NAME_FIELD]?: string;

    [CHAPTER_FIELD]?: string;
    [CHAPTER_LABEL_FIELD]?: string;

    [FUNCTION_FIELD]?: string;
    [FUNCTION_LABEL_FIELD]?: string;

    [BUDGET_YEAR_FIELD]?: number;
    [SECTION_FIELD]?: string;
    [EXPENSE_INCOME_FIELD]?: string;
    [REAL_ORDER_FIELD]?: string;
    [LINE_CODE_FIELD]?: string;
    [LINE_NAME_FIELD]?: string;
    [BUDGET_LINE_CODE]?: string;

    [ORG_CHART_FINANCE_FIELD]?: string;
    [ORG_CHART_FINANCE_SOFTWARE_ID]?: string;
    [ORG_CHART_FINANCE_CODE_FIELD]?: string;

    [GESTIONNAIRE_FIELD]?: string;
    [GESTIONNAIRE_CODE_FIELD]?: string;
    [GESTIONNAIRE_SOFTWARE_ID]?: string;

    [SUPER_GESTIONNAIRE_CODE_FIELD]?: string;
    [SUPER_GESTIONNAIRE_FIELD]?: string;

    [OPERATION_FIELD]?: string;
    [OPERATION_NAME_FIELD]?: string;
    [SUPER_OPERATION_FIELD]?: string;
    [SUPER_OPERATION_NAME_FIELD]?: string;
    [OPERATION_SEGMENT_CODE]?: string;
    [OPERATION_SEGMENT_NAME]?: string;
    [IS_AMPMETROPOLE_BUDGETABLE]?: boolean; // depends on operation_segment.parent_software_id existence

    [NATURE_FIELD]?: string;
    [NATURE_LABEL_FIELD]?: string;
    [SUB_NATURE_FIELD]?: string;
    [SUB_NATURE_LABEL_FIELD]?: string;

    [ANTENNA_FIELD]?: string;
    [ANTENNA_NAME_FIELD]?: string;

    [STRAT_FOCUS_CODE]?: string;
    [STRAT_FOCUS_NAME]?: string;

    [DIRECTION_CODE]?: string;
    [DIRECTION_LABEL]?: string;

    [ANALYTIC_NAME_FIELD]?: string;
    [ANALYTIC_FIELD]?: string;
    [ANALYTIC_POST_0_NAME]?: string;
    [ANALYTIC_POST_0_CODE]?: string;
    [ANALYTIC_POST_0_TYPE]?: string;
    [ANALYTIC_POST_1_NAME]?: string;
    [ANALYTIC_POST_1_CODE]?: string;
    [ANALYTIC_POST_1_TYPE]?: string;
    [ANALYTIC_POST_2_NAME]?: string;
    [ANALYTIC_POST_2_CODE]?: string;
    [ANALYTIC_POST_2_TYPE]?: string;
    [ANALYTIC_POST_3_NAME]?: string;
    [ANALYTIC_POST_3_CODE]?: string;
    [ANALYTIC_POST_3_TYPE]?: string;
    [ANALYTIC_POST_4_NAME]?: string;
    [ANALYTIC_POST_4_CODE]?: string;
    [ANALYTIC_POST_4_TYPE]?: string;
    [ANALYTIC_POST_5_NAME]?: string;
    [ANALYTIC_POST_5_CODE]?: string;
    [ANALYTIC_POST_5_TYPE]?: string;
    [ANALYTIC_POST_6_NAME]?: string;
    [ANALYTIC_POST_6_CODE]?: string;
    [ANALYTIC_POST_6_TYPE]?: string;
    [ANALYTIC_POST_7_NAME]?: string;
    [ANALYTIC_POST_7_CODE]?: string;
    [ANALYTIC_POST_7_TYPE]?: string;
    [ANALYTIC_POST_8_NAME]?: string;
    [ANALYTIC_POST_8_CODE]?: string;
    [ANALYTIC_POST_8_TYPE]?: string;
    [ANALYTIC_POST_9_NAME]?: string;
    [ANALYTIC_POST_9_CODE]?: string;
    [ANALYTIC_POST_9_TYPE]?: string;

    [AP_LABEL]?: string;
    [AP_START_YEAR]?: string;
    [AP_CODE]?: string;

    [ENVELOPPE_CODE]?: string;
    [ENVELOPPE_LABEL]?: string;

    [BUDGET_LINE_PROGRAM_CODE]?: string;
    [BUDGET_LINE_PROGRAM_NAME]?: string;
    [ANALYTIC_NATURE_CODE]?: string;
    [ANALYTIC_NATURE_NAME]?: string;

    [key: `${typeof BUDGET_LINE_ID}..${number}`]: number;
    [key: `${typeof VOTED_FIELD}..${number}`]: number;
    [key: `${typeof REQUESTED_FIELD}..${number}`]: number;
    [key: `${typeof AMOUNT_SPECIAL_AUTHORIZATION_FIELD}..${number}`]: number;
    [key: `${typeof AMOUNT_AMENDING_DECISION_FIELD}..${number}`]: number;
    [key: `${typeof AMOUNT_VOTED_SUP_FIELD}..${number}`]: number;
    [key: `${typeof VOTED_TOTAL_FIELD}..${number}`]: number;
    [key: `${typeof REALIZED_FIELD}..${number}`]: number;
    [key: `${typeof MANDATED_FIELD}..${number}`]: number;
    [key: `${typeof REPORTED_FIELD}..${number}`]: number;
    [key: `${typeof AMOUNT_AVAILABLE_FIELD}..${number}`]: number;
    [key: `${typeof PERCENT_REALIZED_FIELD}..${number}`]: number;
    [key: `${typeof AMOUNT_ENGAGED_UNPAID}..${number}`]: number;

    [key: `${typeof EVOLUTION_N_N_1}..${number}`]: number;
};

/**
 * Type representing the response of the API call to get the Expense Income Imputations.
 */
export type ExpenseIncomeImputationsT = {
    columns: ResponseColumnT[];
    data: ExpenseIncomeImputationDataT[];
};

/**
 *  Fetches the Expense Income Imputations data.
 */
export const useGetExpenseIncomeImputations = (
    budgetProposalId: number,
    resourceSoftwareId: string,
    expenseOrIncome: string,
): UseQueryResult<ExpenseIncomeImputationsT, HttpError> => {
    const endpoint = `budget_proposals/${budgetProposalId}/${encodeURIComponent(
        resourceSoftwareId,
    )}/${expenseOrIncome}/get_expense_income_imputations_data`;
    return useQuery({
        queryKey: [
            'expenseIncomeImputations',
            budgetProposalId,
            resourceSoftwareId,
            expenseOrIncome,
        ],

        queryFn: async () => {
            const response = await RQAPICallWithData<ExpenseIncomeImputationsT>(
                {
                    endpoint,
                    method: 'GET',
                },
            );
            return response.content.data;
        },
    });
};
